import { ForwardedRef, RefObject, useLayoutEffect } from 'react';

export default function useCustomFwdRef<T>(ref: RefObject<T>, fwdRef?: ForwardedRef<T>)
{
  useLayoutEffect(() =>
  {
    if (fwdRef) {
      if (typeof fwdRef === 'function') {
        fwdRef(ref.current);
      }
      else {
        (fwdRef as any).current = ref.current;
      }
    }
    // eslint-disable-next-line
  }, [ ref ]);
}